import { createApp } from 'vue'
import { createI18n } from '@shared/i18n'
import locales from '../i18n/locales.json'

import Component from '@components/PropertiesWidget.vue'

const i18n = createI18n(locales)

window.app = {
  page: {
    "agents_count": 10,
    "blogs_count": 10,
    "properties_count": 12,
    "properties_rent_path": "/property-for-rent",
    "properties_sale_path": "/property-for-sale"
  }
}

document.addEventListener('DOMContentLoaded', () => {
  createApp(Component).use(i18n).mount('#app-widget')
})
